import { FlexColumn } from 'ui-components/components/flex';
import style from './step-card-body.module.less';
import { useAdvancedShippingNoticeContext } from '../advanced-shipping-notice-context';

export const StepCardBody = ({ children, stepId }) => {
  const { hasStartedStepWithId } = useAdvancedShippingNoticeContext();
  const hasStartedStep = hasStartedStepWithId(stepId);

  if (!hasStartedStep) {
    return null;
  }

  return <FlexColumn className={style['body-wrapper']}>{children}</FlexColumn>;
};
